var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitelabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 289,
    viewBox: "0 0 284 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.516 283.033C219.674 283.033 283.033 219.674 283.033 141.516C283.033 63.359 219.674 0 141.516 0C63.359 0 0 63.359 0 141.516C0 219.674 63.359 283.033 141.516 283.033Z",
    fill: "#C1E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.795 233.014H113.809V288H168.795V233.014Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.375 233.257H136.223V252.512H146.375V233.257Z",
    fill: "#0C57BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.374 286.185C113.374 286.185 113.457 287.885 114.077 287.885C114.698 287.885 138.723 288.134 138.972 287.885C139.221 287.636 139.784 286.92 139.739 286.185H113.374Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.101 281C122.101 281 124.217 276.262 130.955 276.48C140.321 276.787 139.745 286.184 139.745 286.184H113.381V266.813H127.189L127.279 276.934",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.101 281C122.101 281 124.217 276.262 130.955 276.48C140.321 276.787 139.745 286.184 139.745 286.184H113.381V266.813H127.189L127.279 276.934",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 273.175C127.643 273.175 129.574 269.166 131.55 270.189C133.519 271.205 130.533 273.111 127.643 273.175Z",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 273.174L130.546 275.623",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 273.175C127.643 273.175 125.713 269.166 123.737 270.189C121.768 271.205 124.754 273.111 127.643 273.175Z",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 273.174L124.747 275.623",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.207 178.027H196.285V233.014H141.299V178.935C141.299 178.436 141.708 178.027 142.207 178.027Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.871 178.27H163.719V197.526H173.871V178.27Z",
    fill: "#0C57BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.285 178.027H250.364C250.863 178.027 251.272 178.436 251.272 178.935V233.014H196.285V178.027Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.852 178.27H218.7V197.526H228.852V178.27Z",
    fill: "#0C57BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M223.782 233.014H168.795V288H223.782V233.014Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.362 233.257H191.209V252.512H201.362V233.257Z",
    fill: "#0C57BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.782 233.014H277.861C278.359 233.014 278.768 233.423 278.768 233.921V287.092C278.768 287.591 278.359 288 277.861 288H223.782V233.014Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.348 233.257H246.196V252.512H256.348V233.257Z",
    fill: "#0C57BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.381 93.7412L141.427 114.256L133.928 128.027L129.875 121.909L127.381 93.7412Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0666 88.3774C73.7372 86.4659 79.7211 85.2448 89.2531 84.9827C89.2531 84.9827 91.951 90.6022 101.246 90.2761C110.542 89.9501 111.36 84.9827 111.36 84.9827C111.36 84.9827 124.677 85.7115 127.829 94.8408C130.993 104.008 129.625 159.097 129.625 168.067L72.2668 171.071L65.3176 124.421C65.3176 124.421 59.7237 91.6123 68.0666 88.3774Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2669 171.071L77.3494 267.83H95.8956L104.309 188.281L111.271 267.83H129.919L129.625 168.067L72.2669 171.071Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 65.8675C116.782 65.8675 118.827 77.0362 122.708 81.3515C122.766 81.4154 122.766 81.5177 122.695 81.5752C122.037 82.1058 118.668 84.5224 111.367 84.9891L109.826 76.9403C109.826 76.9403 112.786 74.3319 116.788 65.8739L116.782 65.8675Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.523 110.491L65.1579 113.873L66.2447 127.362L129.875 121.909L129.523 110.491Z",
    fill: "#C1E8FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9782 155.69L129.798 153.363L129.9 141.504L68.1689 143.703L69.9782 155.69Z",
    fill: "#C1E8FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8184 87.8148C75.489 85.9033 79.7212 85.2448 89.2532 84.9827C89.2532 84.9827 91.9511 90.6022 101.247 90.2761C110.542 89.9501 111.36 84.9827 111.36 84.9827C111.36 84.9827 124.677 85.7115 127.829 94.8408C130.993 104.008 129.625 159.097 129.625 168.067L72.2669 171.071L65.3177 124.421C65.3177 124.421 61.4691 91.0497 69.8184 87.8148",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2533 84.9827L103.203 112.39L111.354 84.9827C111.354 84.9827 102.033 96.2281 89.2533 84.9827Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.36 84.9827L109.82 76.9339C109.82 76.9339 105.357 77.7266 101.464 74.0953C97.5642 70.4641 95.2883 65.8675 95.2883 65.8675L89.2596 84.9827C89.2596 84.9827 92.2772 91.0689 101.253 90.2761C110.229 89.4834 111.367 84.9827 111.367 84.9827H111.36Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4071 63.7386L89.2533 84.9827C89.2533 84.9827 77.7266 83.2694 71.9921 72.2222C71.9345 72.1071 71.9793 71.9601 72.1007 71.9153C73.5456 71.3399 81.6392 67.9005 85.8074 61.6673C89.5665 56.0542 92.8142 50.5626 93.6261 48.4017C93.6261 48.4017 99.399 51.074 101.458 52.1289",
    fill: "#1F2025"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4071 63.7386L89.2533 84.9827C89.2533 84.9827 77.7266 83.2694 71.9921 72.2222C71.9345 72.1071 71.9793 71.9601 72.1007 71.9153C73.5456 71.3399 81.6392 67.9005 85.8074 61.6673C89.5665 56.0542 92.8142 50.5626 93.6261 48.4017C93.6261 48.4017 99.399 51.074 101.458 52.1289",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.014 55.1847C121.014 55.1847 116.487 69.4348 112.479 74.8752C110.497 77.5603 107.761 76.9722 106.713 76.8315C103.427 76.3968 99.9231 74.4469 95.4096 66.6858L97.1038 62.4216C97.1038 62.4216 95.5567 61.1494 95.237 59.8005C94.9174 58.4515 95.3905 57.077 96.1448 56.7318C97.0271 56.329 98.1267 56.8085 98.9258 58.004L101.457 52.1288C101.457 52.1288 109.027 57.0131 121.014 55.1847Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.863 65.8483L109.372 66.4876C109.66 66.609 109.999 66.4812 110.12 66.1935C110.638 65.0172 111.443 62.7093 112.479 59.7749",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.863 65.8483L109.372 66.4876C109.66 66.609 109.999 66.4812 110.12 66.1935C110.638 65.0172 111.443 62.7093 112.479 59.7749",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.884 71.1353C108.848 71.5189 108.094 71.3399 107.237 70.95C106.24 70.5024 105.37 69.7097 104.692 68.9425",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M109.884 71.1353C108.848 71.5189 108.094 71.3399 107.237 70.95C106.24 70.5024 105.37 69.7097 104.692 68.9425",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M108.049 60.0498C107.748 60.0498 107.505 59.8069 107.505 59.5064C107.505 59.2059 107.748 58.963 108.049 58.963C108.349 58.963 108.592 59.2059 108.592 59.5064C108.592 59.8069 108.349 60.0498 108.049 60.0498Z",
    fill: "#1F2025"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.889 61.9677C114.589 61.9677 114.346 61.7248 114.346 61.4243C114.346 61.1238 114.589 60.8809 114.889 60.8809C115.19 60.8809 115.433 61.1238 115.433 61.4243C115.433 61.7248 115.19 61.9677 114.889 61.9677Z",
    fill: "#1F2025"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2925 46.2153C91.2925 46.2153 99.303 53.7463 112.607 57.1921C118.073 58.605 121.5 59.2571 123.27 59.5C124.44 59.6599 125.502 57.0962 124.229 55.9583C123.801 55.5747 122.983 55.1719 121.448 54.8011C121.448 54.8011 125.847 40.1355 111.252 35.7115C99.0792 32.0164 92.6031 42.8909 91.2861 46.2153H91.2925Z",
    fill: "#0C57BF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.309 169.396V182.457",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0728 286.287C80.0728 286.287 80.1496 287.891 80.7377 287.891C81.3259 287.891 103.976 288.121 104.207 287.891C104.437 287.661 104.974 286.984 104.929 286.287H80.0728Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3007 281.396C88.3007 281.396 90.2953 276.927 96.6436 277.132C105.472 277.419 104.929 286.28 104.929 286.28H80.0728V268.015H93.0955L93.1786 277.56",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3007 281.396C88.3007 281.396 90.2953 276.927 96.6436 277.132C105.472 277.419 104.929 286.28 104.929 286.28H80.0728V268.015H93.0955L93.1786 277.56",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1403 273.175C93.1403 273.175 95.071 269.166 97.0464 270.189C99.0155 271.205 96.0299 273.111 93.1403 273.175Z",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1403 273.174L96.0363 275.623",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1402 273.175C93.1402 273.175 91.2095 269.166 89.234 270.189C87.265 271.205 90.2505 273.111 93.1402 273.175Z",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1402 273.174L90.2377 275.623",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9958 184.976C72.9958 184.976 81.4346 184.011 80.5587 171.071",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.851 168.476C121.851 168.476 121.225 179.926 129.657 180.91",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M189.461 132.486L145.708 108.233C145.269 107.99 144.717 108.149 144.474 108.587L120.221 152.341C119.978 152.779 120.136 153.332 120.575 153.575L164.328 177.828C164.767 178.071 165.319 177.912 165.562 177.474L189.815 133.72C190.058 133.282 189.9 132.729 189.461 132.486Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M171.763 122.677L163.393 118.038L154.479 134.119L162.849 138.758L171.763 122.677Z",
    fill: "#0C57BF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.978 163.59L153.497 156.117L149.784 162.816L163.265 170.288L166.978 163.59Z",
    fill: "#C1E8FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M220.515 158.503C255.311 158.503 283.519 130.295 283.519 95.4992C283.519 60.7034 255.311 32.4958 220.515 32.4958C185.719 32.4958 157.512 60.7034 157.512 95.4992C157.512 130.295 185.719 158.503 220.515 158.503Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M192.469 71.8258H191.555V114.614H192.469V71.8258Z",
    fill: "#1F2025"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.035 71.8258H193.121V114.614H194.035V71.8258Z",
    fill: "#1F2025"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M197.756 71.8258H196.842V110.772H197.756V71.8258Z",
    fill: "#1F2025"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M206.329 71.8258H205.415V110.772H206.329V71.8258Z",
    fill: "#1F2025"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M212.147 71.8258H211.232V110.772H212.147V71.8258Z",
    fill: "#1F2025"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M218.329 71.8258H217.414V110.772H218.329V71.8258Z",
    fill: "#1F2025"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M219.978 71.8258H219.064V114.614H219.978V71.8258Z",
    fill: "#1F2025"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M221.634 71.8258H220.72V114.614H221.634V71.8258Z",
    fill: "#1F2025"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M227.637 71.8258H226.723V110.772H227.637V71.8258Z",
    fill: "#1F2025"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M233.902 71.8258H232.988V110.772H233.902V71.8258Z",
    fill: "#1F2025"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M239.899 71.8258H238.985V110.772H239.899V71.8258Z",
    fill: "#1F2025"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M241.644 71.8258H240.73V110.772H241.644V71.8258Z",
    fill: "#1F2025"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M245.927 71.8258H245.013V110.772H245.927V71.8258Z",
    fill: "#1F2025"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M247.73 71.8258H246.816V114.614H247.73V71.8258Z",
    fill: "#1F2025"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M249.476 71.8258H248.561V114.614H249.476V71.8258Z",
    fill: "#1F2025"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.064 71.8258H198.408V110.772H200.064V71.8258Z",
    fill: "#1F2025"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M202.698 71.8258H201.042V110.772H202.698V71.8258Z",
    fill: "#1F2025"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 71.8258H208.784V110.772H210.44V71.8258Z",
    fill: "#1F2025"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M214.723 71.8258H213.067V110.772H214.723V71.8258Z",
    fill: "#1F2025"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M225.092 71.8258H222.701V110.772H225.092V71.8258Z",
    fill: "#1F2025"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M231 71.8258H228.609V110.772H231V71.8258Z",
    fill: "#1F2025"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M237.182 71.8258H234.791V110.772H237.182V71.8258Z",
    fill: "#1F2025"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M252.129 71.8258H251.214V110.772H252.129V71.8258Z",
    fill: "#1F2025"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M258.125 71.8258H257.211V110.772H258.125V71.8258Z",
    fill: "#1F2025"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M259.871 71.8258H258.956V110.772H259.871V71.8258Z",
    fill: "#1F2025"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M255.408 71.8258H253.017V110.772H255.408V71.8258Z",
    fill: "#1F2025"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M182.035 71.8257H181.121V110.772H182.035V71.8257Z",
    fill: "#1F2025"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M188.032 71.8258H187.118V110.772H188.032V71.8258Z",
    fill: "#1F2025"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M189.777 71.8258H188.863V110.772H189.777V71.8258Z",
    fill: "#1F2025"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M185.315 71.8258H182.924V110.772H185.315V71.8258Z",
    fill: "#1F2025"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 119.166C198.913 119.198 198.587 119.109 198.325 118.93C198.088 118.783 197.909 118.546 197.82 118.278C197.705 117.952 197.641 117.626 197.673 117.3C197.673 117.063 197.705 116.794 197.762 116.558C197.82 116.379 197.877 116.232 197.999 116.085C198.088 115.97 198.203 115.88 198.325 115.791C198.44 115.733 198.529 115.644 198.651 115.586C198.382 115.471 198.146 115.292 197.999 115.024C197.82 114.73 197.73 114.371 197.762 114.02C197.762 113.726 197.82 113.432 197.909 113.163C197.999 112.927 198.178 112.722 198.382 112.575C198.651 112.428 198.971 112.339 199.271 112.37C199.565 112.339 199.891 112.428 200.16 112.575C200.364 112.722 200.543 112.927 200.633 113.163C200.722 113.432 200.78 113.726 200.78 114.02C200.812 114.371 200.722 114.73 200.543 115.024C200.396 115.26 200.16 115.465 199.891 115.554C200.006 115.612 200.128 115.669 200.217 115.759C200.332 115.848 200.422 115.938 200.511 116.053C200.626 116.2 200.69 116.347 200.748 116.526C200.805 116.762 200.837 116.999 200.837 117.268C200.837 117.594 200.78 117.945 200.69 118.246C200.601 118.514 200.422 118.751 200.185 118.898C199.859 119.102 199.565 119.166 199.239 119.166ZM199.239 118.693C199.444 118.693 199.623 118.636 199.77 118.546C199.917 118.431 200.038 118.278 200.096 118.073C200.243 117.568 200.243 117.069 200.096 116.564C200.038 116.385 199.949 116.213 199.802 116.059C199.655 115.906 199.45 115.855 199.239 115.855C199.028 115.855 198.824 115.944 198.651 116.059C198.504 116.174 198.382 116.353 198.325 116.564C198.267 116.801 198.235 117.037 198.235 117.274C198.235 117.542 198.267 117.805 198.35 118.041C198.44 118.457 198.823 118.719 199.239 118.693ZM199.239 115.324C199.444 115.324 199.623 115.267 199.77 115.145C199.917 115.03 200.006 114.851 200.038 114.672C200.096 114.467 200.128 114.231 200.128 114.02C200.16 113.694 200.07 113.4 199.923 113.131C199.744 112.927 199.508 112.805 199.245 112.837C198.977 112.805 198.715 112.927 198.536 113.131C198.357 113.4 198.299 113.694 198.331 114.02C198.331 114.224 198.363 114.461 198.421 114.672C198.478 114.851 198.568 115.024 198.715 115.145C198.862 115.235 199.041 115.292 199.245 115.324H199.239Z",
    fill: "#1F2025"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M204.174 119.166C203.88 119.166 203.586 119.109 203.35 118.987C203.113 118.872 202.934 118.693 202.845 118.457C202.73 118.188 202.666 117.894 202.666 117.6V117.485H203.254C203.222 117.811 203.286 118.105 203.458 118.399C203.785 118.693 204.283 118.751 204.673 118.546C204.82 118.431 204.942 118.278 204.967 118.105C205.057 117.837 205.082 117.542 205.082 117.248V115.976C204.967 116.091 204.846 116.181 204.699 116.245C204.494 116.334 204.258 116.36 204.021 116.36C203.727 116.392 203.433 116.302 203.164 116.155C202.96 116.008 202.781 115.772 202.723 115.503C202.634 115.151 202.576 114.762 202.608 114.378C202.608 114.026 202.666 113.636 202.755 113.317C202.845 113.023 203.024 112.786 203.26 112.607C203.529 112.428 203.848 112.339 204.174 112.339C204.501 112.307 204.795 112.396 205.063 112.607C205.3 112.786 205.479 113.048 205.568 113.317C205.683 113.668 205.747 114.058 205.715 114.442V117.101C205.715 117.453 205.683 117.843 205.568 118.163C205.479 118.457 205.332 118.693 205.095 118.904C204.827 119.083 204.507 119.198 204.181 119.173L204.174 119.166ZM204.174 115.887C204.379 115.887 204.59 115.855 204.763 115.772C204.878 115.714 204.999 115.625 205.114 115.503V114.352C205.114 114.058 205.082 113.764 205.025 113.464C204.967 113.08 204.609 112.786 204.2 112.812C204.021 112.812 203.816 112.869 203.669 112.959C203.522 113.074 203.401 113.227 203.343 113.432C203.254 113.7 203.228 113.962 203.228 114.231C203.228 114.525 203.26 114.851 203.286 115.145C203.318 115.35 203.401 115.529 203.554 115.676C203.701 115.855 203.938 115.912 204.174 115.88V115.887Z",
    fill: "#1F2025"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M209.493 119.109V117.159H207.486V116.539L209.378 112.428H210.088V116.596H210.855V117.127H210.088V119.077H209.5V119.109H209.493ZM208.074 116.596H209.462V113.195L208.074 116.596Z",
    fill: "#1F2025"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M212.773 119.109L214.071 112.901H212.063V112.428H214.691V112.722L213.361 119.102H212.773V119.109Z",
    fill: "#1F2025"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M226.013 119.166C225.687 119.198 225.361 119.109 225.067 118.898C224.83 118.719 224.651 118.482 224.562 118.188C224.472 117.862 224.415 117.51 224.415 117.184V114.288C224.415 113.937 224.472 113.611 224.562 113.285C224.651 113.016 224.83 112.754 225.067 112.607C225.335 112.428 225.655 112.339 225.981 112.37C226.307 112.339 226.633 112.428 226.927 112.607C227.164 112.786 227.343 113.023 227.432 113.285C227.547 113.611 227.579 113.962 227.579 114.288V117.184C227.579 117.536 227.522 117.862 227.432 118.22C227.343 118.489 227.164 118.751 226.927 118.93C226.691 119.109 226.339 119.198 226.013 119.166ZM226.013 118.693C226.218 118.693 226.429 118.636 226.601 118.489C226.748 118.342 226.838 118.163 226.895 117.958C226.953 117.721 226.985 117.485 226.985 117.216V114.263C226.985 114.026 226.953 113.758 226.895 113.521C226.838 113.317 226.748 113.138 226.601 112.991C226.422 112.876 226.218 112.786 226.013 112.812C225.809 112.812 225.598 112.869 225.425 112.991C225.278 113.138 225.188 113.317 225.131 113.521C225.073 113.758 225.041 113.994 225.041 114.263V117.248C225.041 117.485 225.073 117.753 225.131 117.99C225.188 118.195 225.278 118.374 225.425 118.521C225.604 118.636 225.809 118.7 226.013 118.7V118.693Z",
    fill: "#1F2025"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M231.096 119.166C230.77 119.198 230.443 119.109 230.149 118.898C229.913 118.719 229.734 118.482 229.644 118.188C229.529 117.862 229.497 117.51 229.497 117.184V114.288C229.497 113.937 229.555 113.611 229.644 113.285C229.734 113.016 229.913 112.754 230.149 112.607C230.738 112.281 231.447 112.281 232.01 112.607C232.246 112.786 232.425 113.022 232.515 113.285C232.63 113.611 232.662 113.962 232.662 114.288V117.184C232.662 117.536 232.604 117.862 232.515 118.22C232.425 118.489 232.246 118.751 232.01 118.93C231.773 119.109 231.447 119.198 231.096 119.166ZM231.096 118.693C231.3 118.693 231.511 118.636 231.684 118.489C231.831 118.341 231.92 118.162 231.978 117.958C232.035 117.721 232.067 117.485 232.067 117.216V114.263C232.067 114.026 232.035 113.758 231.978 113.521C231.92 113.317 231.831 113.138 231.684 112.991C231.332 112.754 230.859 112.754 230.501 112.991C230.354 113.138 230.264 113.317 230.207 113.521C230.149 113.758 230.117 113.994 230.117 114.263V117.248C230.117 117.485 230.149 117.753 230.207 117.99C230.264 118.194 230.354 118.373 230.501 118.52C230.68 118.636 230.885 118.699 231.089 118.699L231.096 118.693Z",
    fill: "#1F2025"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236.178 119.166C235.852 119.198 235.526 119.109 235.232 118.898C234.995 118.719 234.816 118.482 234.727 118.188C234.637 117.862 234.58 117.51 234.58 117.184V114.288C234.58 113.937 234.637 113.611 234.727 113.285C234.816 113.016 234.995 112.754 235.232 112.607C235.5 112.428 235.82 112.339 236.146 112.37C236.472 112.339 236.798 112.428 237.092 112.607C237.329 112.786 237.508 113.023 237.597 113.285C237.712 113.611 237.744 113.962 237.744 114.288V117.184C237.744 117.536 237.687 117.862 237.597 118.22C237.508 118.489 237.329 118.751 237.092 118.93C236.856 119.109 236.53 119.198 236.178 119.166ZM236.178 118.693C236.383 118.693 236.594 118.636 236.766 118.489C236.913 118.342 237.003 118.163 237.06 117.958C237.118 117.721 237.15 117.485 237.15 117.216V114.263C237.15 114.026 237.118 113.758 237.06 113.521C237.003 113.317 236.913 113.138 236.766 112.991C236.587 112.876 236.383 112.786 236.178 112.812C235.973 112.812 235.762 112.869 235.59 112.991C235.443 113.138 235.353 113.317 235.296 113.521C235.238 113.758 235.206 113.994 235.206 114.263V117.248C235.206 117.485 235.238 117.753 235.296 117.99C235.353 118.195 235.443 118.374 235.59 118.521C235.769 118.636 235.973 118.7 236.178 118.7V118.693Z",
    fill: "#1F2025"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M239.988 119.109L241.286 112.933H239.279V112.46H241.906V112.754L240.576 119.134H239.988V119.102V119.109Z",
    fill: "#1F2025"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M103.19 111.686L104.309 169.396",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8184 87.8148C59.7558 91.7146 50.358 93.8818 57.7356 111.495C61.9422 121.551 71.992 143.767 79.2481 144.265C86.0248 144.732 107.205 136.031 109.967 134.887C110.133 134.816 110.21 134.625 110.146 134.458C109.551 132.956 106.943 126.333 106.08 123.852C106.022 123.68 105.83 123.59 105.658 123.648C103.829 124.268 94.5083 127.394 90.4871 128.296C89.7199 128.468 87.5719 128.858 86.6705 127.356C81.3898 118.61 69.8184 87.8084 69.8184 87.8084V87.8148Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 119.339C118.7 119.339 124.415 107.019 126.083 107.019C127.036 107.019 130.667 107.927 134.906 110.229C136.479 111.085 136.095 111.642 135.769 112.511C134.983 114.582 133.627 117.843 132.873 118.616C132.17 119.332 130.36 118.271 129.306 117.913C128.577 117.67 128.104 117.907 127.484 118.495L125.022 121.282C124.907 121.41 124.728 121.449 124.575 121.378C123.609 120.924 120.176 119.352 118.7 119.339Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M131.275 118.687C131.275 118.687 132.528 118.968 132.866 118.616C133.621 117.843 134.983 114.582 135.763 112.511C136.095 111.642 136.472 111.079 134.899 110.229L131.268 118.687H131.275Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M122.555 280.84C122.555 280.84 123.75 278.257 126.934 277.157L122.555 280.84Z",
    fill: "#0C57BE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M122.555 280.84C122.555 280.84 123.75 278.257 126.934 277.157",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3007 281.396C88.3007 281.396 89.4962 278.813 92.6799 277.714L88.3007 281.396Z",
    fill: "#0C57BE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3007 281.396C88.3007 281.396 89.4962 278.813 92.6799 277.714",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M106.15 124.044C106.15 124.044 117.536 119.211 118.7 119.332C119.863 119.454 124.108 120.394 125.86 122.107C127.611 123.814 126.442 125.342 125.233 125.157C125.233 125.157 126.563 127.349 124.076 127.349C124.076 127.349 124.888 129.593 122.471 129.517C122.471 129.517 122.427 131.53 120.509 130.949C118.591 130.367 116.117 128.909 115.573 128.954C115.03 128.999 109.078 131.748 109.078 131.748L106.144 124.038L106.15 124.044Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelabel);
export default __webpack_public_path__ + "static/media/whitelabel.9d46c27ebe1d21f52521fcf32bdeb0e5.svg";
export { ForwardRef as ReactComponent };